import { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface MobileHeaderProps {
  title: string;
  right?: ReactNode;
  showBack?: boolean;
  backTo?: string;
}

export function MobileHeader({ title, right, showBack = false, backTo }: MobileHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur-sm pt-safe">
      <div className="flex h-12 items-center justify-between px-3">
        <div className="w-10">
          {showBack ? (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              aria-label="Voltar"
              onClick={() => {
                if (backTo) {
                  navigate(backTo);
                  return;
                }
                navigate(-1);
              }}
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          ) : null}
        </div>
        <h1 className="truncate text-sm font-semibold">{title}</h1>
        <div className="flex w-10 items-center justify-end">{right}</div>
      </div>
    </header>
  );
}
